import { getImages as getTrending } from '../global/helpers';

import { useQuery } from 'react-query';

export default function useFetchTrending(key, url) {
  return useQuery(key, () => getTrending(url).then((resp) => resp.data));
}
